﻿(function (angular) {
  "use strict";

  const DEALER_SELECTOR_CLOSED_CHECK_DELAY_MS = 300;
  const GET_DEALER_URL_LOADER_TIMEOUT_MS = 5000;
  const GET_DEALER_URL_LOADER_MIN_DURATION_MS = 300;

  angular.module("Toyota").directive("tyTfy", function () {
    var controller = [
      "$scope",
      "$timeout",
      "Location",
      "Dealer",
      "DealerInventoryService",
      "Tfy",
      "DealerSelector",
      "$attrs",
      "PricingPageAnalyticsService",
      "ParseBool",
      function (
        $scope,
        $timeout,
        Location,
        Dealer,
        DealerInventoryService,
        Tfy,
        DealerSelector,
        $attrs,
        PricingPageAnalyticsService,
        ParseBool
      ) {
        var ctl = this;
        $scope.init = function () {
          $scope.$on("GeoPostCode", function (event, postcode) {
            $scope.geoPostCode = postcode;
          });

          $scope.geoPostCode = Location.get().postcode;
          $scope.getDealerUrlIsLoading = false;

          var dealerObject = Dealer.getSavedFallbackToDefault();

          Tfy.updateDealerInTfyCookie(
            dealerObject?.sapDealerCode,
            dealerObject?.branchCode
          );
        };

        $scope.isFirstTime = true;
        $scope.getDealerUrlIsLoading = false;
        $scope.tfyModel = false;
        $scope.fallbackBaseUrl = null;
        $scope.isDealerLocatorClosed = false;

        $scope.isPersonalizePage = !!document.getElementById("personalizePage");

        $scope.init();
        ctl.defaultTimeout = 100;
        $scope.getDealerUrlWaitTimeout = 700;

        $scope.goToTfyPage = function (tfyModelName) {
          ctl.redirectToDealerPage(tfyModelName);
        };

        // This is to support legacy dealer locator
        $scope.$on("modal-close", function () {
          if (DealerSelector.getIsUsingLegacy()) {
            ctl.redirect();
            if ($scope.isFirstTime) {
              ctl.addFirstTimeAnalyticEvent();
            } else {
              ctl.addDealerSelectChange();
            }
          }
        });

        $scope.$on("did-dealer-selector-close", function () {
          $scope.isDealerLocatorClosed = true;
        });

        $scope.$on("dealer-selected", function () {
          ctl.setFallbackDealerPage();
          setTimeout(() => {
            if ($scope.isDealerLocatorClosed) {
              if (!DealerSelector.getIsUsingLegacy()) {
                if ($scope.isFirstTime) {
                  ctl.redirect();
                  ctl.addFirstTimeAnalyticEvent();
                  $scope.isFirstTime = false;
                } else {
                  ctl.addDealerSelectChange();
                }
              }

              $scope.isDealerLocatorClosed = false;
            }
          }, DEALER_SELECTOR_CLOSED_CHECK_DELAY_MS);
        });

        ctl.getDomainFromUrl = function (url) {
          var parsedUrl = new URL(url);

          if (!parsedUrl || !parsedUrl.hostname) {
            return "";
          }

          var formattedUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
          // Extract and return the domain
          return formattedUrl;
        };

        ctl.redirect = function () {
          function checkAndRedirect() {
            if ($scope.getDealerUrlIsLoading) {
              setTimeout(() => {
                checkAndRedirect();
              }, $scope.getDealerUrlWaitTimeout);
            } else {
              if ($scope.tfyModel) {
                ctl.redirectToDealerPage(null);
              }

              $scope.tfyModel = false;
            }
          }

          checkAndRedirect();
        };

        ctl.getDomainFromUrl = function (url) {
          var parsedUrl = new URL(url);

          if (!parsedUrl || !parsedUrl.hostname) {
            return "";
          }

          var formattedUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
          // Extract and return the domain
          return formattedUrl;
        };

        ctl.redirectToDealerPage = function (tfyModelNameOrNull) {
          var savedDealerObject = Dealer.getSaved();
          var latestVehicle = Tfy.getLatestVehicle();
          var hasSelectedDealer = !!savedDealerObject.branchCode;
          var tfyModelName =
            tfyModelNameOrNull ??
            Tfy.getCurrentPageVehicleModel()?.tfyModelName ??
            latestVehicle?.model;
          var materialCode = Tfy.getCachedMaterialCode(tfyModelName) ?? "";

          var materialCodeString = "";
          if (!$scope.isPersonalizePage) {
            materialCodeString = `&MC=${materialCode}`;
          }

          if (hasSelectedDealer) {
            if (
              savedDealerObject.orderAndCollectFlag &&
              savedDealerObject.orderAndCollectURL
            ) {
              ctl.openWindow(
                `${savedDealerObject.orderAndCollectURL}/toyota-for-you?vehicle=${tfyModelName}&SC=${savedDealerObject.branchCode}${materialCodeString}`,
                "_blank"
              );
              ctl.addCtaClickAnalyticEvent();
            } else if ($scope.fallbackBaseUrl) {
              ctl.openWindow(
                `${$scope.fallbackBaseUrl}/toyota-for-you?vehicle=${tfyModelName}&SC=${savedDealerObject.branchCode}${materialCodeString}`,
                "_blank"
              );
              ctl.addCtaClickAnalyticEvent();
            }
          } else {
            // visitor haven't selected dealer.

            // get from default dealer
            var defaultDealerObject = Dealer.getSavedFallbackToDefault();

            var hasNoPostCode = !defaultDealerObject.branchCode;

            if (
              hasNoPostCode ||
              (defaultDealerObject && !!defaultDealerObject.branchCode)
            ) {
              // Visitor haven't choose dealer. prompt the dealer dialog
              DealerSelector.openDealerSelector();
              $scope.tfyModel = true;
            } else if ($scope.fallbackBaseUrl) {
              ctl.openWindow(
                `${$scope.fallbackBaseUrl}/toyota-for-you?vehicle=${tfyModelName}&SC=${savedDealerObject.branchCode}${materialCodeString}`,
                "_blank"
              );
            }
          }
        };

        ctl.showTfyRegion = function () {
          var dealerObject = Dealer.getSavedFallbackToDefault();

          if (dealerObject === null || !dealerObject.branchCode) {
            // user haven't selected any dealer or postcode.
            return true;
          }

          if (
            dealerObject.orderAndCollectFlag &&
            dealerObject.orderAndCollectURL
          ) {
            return true;
          }

          return !!$scope.fallbackBaseUrl;
        };

        ctl.setFallbackDealerPage = function () {
          var dealerObject = Dealer.getSavedFallbackToDefault();

          // User hasn't selected a dealer
          if (dealerObject === null) {
            return;
          }

          // When we have an orderAndCollectURL, we just use that
          if (
            dealerObject.orderAndCollectFlag &&
            dealerObject.orderAndCollectURL
          ) {
            return;
          }

          var currentTfyModelName =
            Tfy.getCurrentPageVehicleModel()?.tfyModelName;

          // Fallback case: going straight to personalise page without hitting BEP first
          var currentMaterialCode =
            Tfy.getCachedMaterialCode(currentTfyModelName) ??
            Tfy.getCachedFallbackMaterialCode(currentTfyModelName);

          if (!dealerObject.branchCode || !currentMaterialCode) {
            return;
          }

          var request = DealerInventoryService.get(
            dealerObject,
            currentMaterialCode
          );

          $scope.fallbackBaseUrl = null;
          $scope.getDealerUrlIsLoading = true;

          // unblock guest if wait time exceed 5 seconds
          var timeoutPromise = $timeout(function () {
            $scope.getDealerUrlIsLoading = false;
          }, GET_DEALER_URL_LOADER_TIMEOUT_MS);

          request
            .then(function (result) {
              $timeout(function () {
                $scope.getDealerUrlIsLoading = false;

                if (
                  !result ||
                  !result.data ||
                  !result.data.success ||
                  !result.data.url
                ) {
                  return;
                }

                var url = ctl.getDomainFromUrl(result.data.url);

                $scope.fallbackBaseUrl = url;
              }, GET_DEALER_URL_LOADER_MIN_DURATION_MS);
            })
            .catch(() => {
              // Handle errors from the API call
              $scope.getDealerUrlIsLoading = false;
            });
        };

        ctl.openWindow = function (url, target) {
          if (target) {
            window.open(url, target);
          } else {
            window.open(url);
          }
        };

        ctl.addCtaClickAnalyticEvent = function () {
          var analyticsData = angular.extend(
            {},
            {
              module_name: "Toyota For You",
              click_text: $attrs.tyTfyCtaLabel,
              click_type: "Button",
            }
          );

          if (
            ParseBool($attrs.tyTfyAugmentAnalyticsWithCurrentPageVehicleModel)
          ) {
            analyticsData.vehicle_model =
              Tfy.getCurrentPageVehicleModel()?.modelName;
          }

          PricingPageAnalyticsService.triggerAnalyticsBatch(
            "click_secondary_interaction",
            analyticsData
          );
        };

        ctl.addFirstTimeAnalyticEvent = function () {
          var dealerObject = Dealer.getSaved();

          if (
            !dealerObject ||
            !dealerObject.postCode ||
            !dealerObject.branchCode
          ) {
            return;
          }

          $scope.isFirstTime = false;
          var analyticsData = angular.extend(
            {},
            {
              dealer_location_type: "Principal/Branch",
              dealer_name: dealerObject.name,
              dealer_postcode: dealerObject.postCode,
            }
          );
          PricingPageAnalyticsService.triggerAnalyticsBatch(
            "click_set_dealership",
            analyticsData
          );
        };

        ctl.addDealerSelectChange = function () {
          var dealerObject = Dealer.getSavedFallbackToDefault();
          var previousDealer = Dealer.getPrevSaved();

          if (!dealerObject || !dealerObject.name) {
            return;
          }

          if (!!previousDealer && dealerObject.name === previousDealer.name) {
            return;
          }

          var analyticsData = angular.extend(
            {},
            {
              dealer_location_type: "Principal/Branch",
              dealer_name: dealerObject.name,
              dealer_postcode: dealerObject.postCode,
              previous_dealer_selection_name: previousDealer?.name ?? "",
              previous_dealer_location_type: "Principal/Branch",
            }
          );
          PricingPageAnalyticsService.triggerAnalyticsBatch(
            "click_change_dealership",
            analyticsData
          );
        };

        ctl.setFallbackDealerPage();
      },
    ];

    return {
      scope: true,
      restrict: "A",
      controller: controller,
      controllerAs: "tfyController",
      bindToController: true,
    };
  });
})(window.angular);
